import { render, staticRenderFns } from "./Theories.vue?vue&type=template&id=2075b094&"
import script from "./Theories.vue?vue&type=script&lang=js&"
export * from "./Theories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports